import { View } from "react-native";
import React, { useState } from "react";
import { BuyFlowUser } from "features/types";
import { Divider, List, ListItem, Text } from "@ui-kitten/components";
import {
  initialChildUser,
  initialPrimaryUser,
  setEditingChild,
  setEditingUser,
  setStep,
} from "features/slices/buyFlowSlice";
import Button from "components/Button";
import { useAppDispatch } from "hooks/useAppDispatch";
import toast from "utils/toast";
import EditMemberModal from "screens/Register/components/EditMemberModal";
import { useAppSelector } from "hooks/useAppSelector";
import { userEmailUsedByOtherUsers } from "screens/Register/StepTwo";
import { Entypo } from "@expo/vector-icons";
import usePrimaryMember from "hooks/usePrimaryMember";
import { setNewMembers } from "features/slices/addMembershipFlowSlice";
import { getUserName } from "utils/userUtils";

const StepTwo = () => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);

  const { editingUser, step } = useAppSelector((state) => state.buyFlow);
  const { adultMemberQuantity, childMemberQuantity, newMembers } =
    useAppSelector((state) => state.addMembershipFlow);
  const primaryMember = usePrimaryMember();
  const [currentMemberIndex, setCurrentMemberIndex] = useState(0);
  const arrayWithQuantityAsLength = Array(
    adultMemberQuantity + childMemberQuantity
  ).fill(0);

  const handleNewMemberSubmit = async (member: BuyFlowUser) => {
    const updatedNewMembers = [...newMembers];
    updatedNewMembers[currentMemberIndex] = member;

    if (member.minor) {
      dispatch(setNewMembers(updatedNewMembers));
      setVisible(false);
      return;
    }
    // check duplicated email used by another member
    if (
      userEmailUsedByOtherUsers(
        member.email as string,
        newMembers,
        editingUser,
        primaryMember,
        null
      )
    ) {
      toast.error(`${member.email} is already being used by another member.`);
      return;
    }

    dispatch(setNewMembers(updatedNewMembers));
    setVisible(false);
  };

  const isUserInfoEntered = (index: number) => {
    return newMembers[index]?.firstName !== undefined;
  };
  // button should be disabled if any of the member's first name is empty
  const isDisabled =
    newMembers.length < adultMemberQuantity + childMemberQuantity;

  return (
    <View>
      <EditMemberModal
        visible={visible}
        setVisible={setVisible}
        handleNewMemberSubmit={handleNewMemberSubmit}
      />
      <List
        data={arrayWithQuantityAsLength}
        ItemSeparatorComponent={Divider}
        renderItem={({ index }) => {
          const isEditingChild = index >= adultMemberQuantity;
          return (
            <ListItem
              accessoryLeft={() =>
                isUserInfoEntered(index) ? (
                  <Entypo name="check" size={24} color="green"></Entypo>
                ) : (
                  <></>
                )
              }
              title={(props) =>
                isUserInfoEntered(index) ? (
                  <Text {...props}>{getUserName(newMembers[index])}</Text>
                ) : (
                  <Text {...props}>{isEditingChild ? "Child" : "Adult"}</Text>
                )
              }
              accessoryRight={
                <Button
                  testID="edit-member-button"
                  appearance="ghost"
                  onPress={() => {
                    let editingUser = newMembers[index];

                    if (!isUserInfoEntered(index)) {
                      if (isEditingChild) {
                        editingUser = initialChildUser;
                      } else {
                        editingUser = initialPrimaryUser;
                      }
                    }
                    dispatch(setEditingUser(editingUser));
                    dispatch(setEditingChild(isEditingChild));
                    setCurrentMemberIndex(index);
                    setVisible(true);
                  }}
                >
                  Edit
                </Button>
              }
            ></ListItem>
          );
        }}
      ></List>
      <Button
        style={{ marginTop: 25 }}
        disabled={isDisabled}
        onPress={() => dispatch(setStep(3))}
        testID="add-membership-step-two-button"
      >
        Continue
      </Button>
      <Button
        appearance="ghost"
        style={{ marginTop: 15 }}
        onPress={() => dispatch(setStep(step - 1))}
      >
        BACK
      </Button>
    </View>
  );
};

export default StepTwo;
